
export const HTTP_CODE = {
  SUCCESS: 200,
  FAIL: -1
};

export const TemplateType = {
  Normal: '1',
  Evaluation: '2',
  Gift: '3'
};

export const VehicleConfig = {
  Need: '0',
  Option: '1',
  Skip: '2'
};

export const ZBServicePhone = {
  number: '4000026862',
  text: '400-002-6862'
};

export const ServiceSteps = {
	Driving: ['下单', '师傅联系', '代驾服务', '到达终点'], // 代驾
	FreeInspect: ['下单', '年检办理', '材料回寄', '服务完成'], // 免上线年检
	Rescue: ['下单', '师傅联系', '现场服务', '作业完成'], // 道路救援
	TakeCarInspect: ['下单', '师傅联系', '年检办理', '服务完成'], // 上线年检
	SafetyInspect: ['下单', '自驾前往', '现场服务', '出示二维码'] // 安全检测
};

export const Services = {
	// Driving: '0100',
	// Inspect: '0200',  // 只有免上线年检
	// Rescue: '0300',
  // GlassRepair: '0400', // 玻璃修复大类是 0400 小类是 0401 但是这里只返回大类
  // PaintRepair: '0403', // 划痕补漆大类是 0400 但是 step 顺序不一样，所以这里要兼容一下
	// SafetyInspect: '0404', //安全检测
	// FreeInspect: '0201', // 免上线年检
	// TakeCarInspect: '0202', // 上线年检(取送车)
	// DriveInspect: '0203', // 上线年检(自驾)

  // 父类code
	DrivingParent: 'FL70000001',
	InspectParent: 'FL60000001', // 年检
	RescueParent: 'FL10000001',
	CarMaintainParent: 'FL11000001', // 汽车类的汽车养护，后台有两个汽车养护
	SafetyInspectParent: 'FL40000001', // 安全检测
	AccidentRescueParent: 'FL90000001', // 事故救援

    GlassRepair: '0400', // 玻璃修复大类是 0400 小类是 0401 但是这里只返回大类
    PaintRepair: '0403', // 划痕补漆大类是 0400 但是 step 顺序不一样，所以这里要兼容一下

	// 分类code
	SafetyInspect: 'FL40000002', // 安全检测
	FreeInspect: 'FL60000002', // 免上线年检
	TakeCarInspect: 'FL60000004', // 上线年检(取送车)
	DriveInspect: 'FL60000003', // 上线年检(自驾)
	CarWash: 'FL11000002', // 洗车
	Driving: 'FL70000002', // 代驾
	Trailer: 'FL10000002' // 拖车
};

export const ServiceTypes = {
	'0100': '代驾',
	'0200': '机动车年检',
	'0300': '道路救援',
  '0400': '汽车养护'
};

export const OrderStatus = {
  '00': '待派单',
  '01': '处理中',
  '02': '待初审',
  '03': '初审退回',
  '04': '待终审',
  '05': '终审退回',
  '06': '终审通过',
  '07': '已办结',
  '08': '已取消',
  '09': '待补充'
};

// 订单状态描述
export const OrderStatusTxt = {
  // '00': '派单中',
  // '01': '处理中',
  // '02': '已完成',
  // '03': '已完成',
  // '04': '已完成',
  // '05': '已完成',
  // '06': '已完成',
  // '07': '已完成',
  // '08': '已撤销',
  // '09': '待处理'
  'ADD_INFO_WAIT': '待补充',
  'PAID_WAIT': '待支付',
  'DISPATCH_WAIT': '待调度',
  'PROCESSING': '处理中',
  'AUDIT_WAIT': '已完成',
  'AUDIT_RETURN': '已完成',
  'SETTLEMENT_WAIT': '已完成',
  'SETTLEMENT_RETURN': '已完成',
  'SETTLEMENT': '已完成',
  'FINISHED': '已完成',
  'CANCEL': '已取消'
};
export const TaskStatus = {
  // '00': '派单中',
  // '01': '派单中',
  // '02': '处理中', //已接单
  // '03': '已完成',
  // '04': '已撤销',
  // '05': '处理中', //已到达
  // '06': '处理中',
  // '07': '处理中',
  // '08': '已撤销',

  'DISPATCH_FAIL': '派单失败',
  'DISPATCH_WAIT': '待派单（待派工）',
  'TAKE_WAIT': '待接单(已派工)',
  'TAKE': '已接单',
  'START': '已出发',
  'ARRIVE': '已到达',
  'WORK_START': '作业开始',
  'WORK_END': '作业结束',
  'CANCELING': '取消中（无费）',
  'CANCELING_FEE': '取消中（有费）',
  'CANCEL': '已撤销（无费）',
  'CANCEL_FEE': '已办理（撤销有费）',
  'CANCEL_ORDER': '已办理（撤销订单）',
  'FINISH': '已办理(服务完成)'
};
// 任务状态描述
export const TaskStatusTxt = {
  // '00': '待派工',
  // '01': '待接单',
  // '02': '已接单',
  // '03': '已办理',
  // '04': '已撤销（无费用）',
  // '05': '已到达',
  // '06': '作业开始',
  // '07': '作业结束',
  // '08': '已撤销（有费用）'
  'DISPATCH_WAIT': '待派工',
  'TAKE_WAIT': '待接单',
  'TAKE': '已接单',
  '03': '已办理',
  '04': '已撤销（无费用）',
  '05': '已到达',
  '06': '作业开始',
  '07': '作业结束',
  '08': '已撤销（有费用）'
};

// 车生活订单状态
export const CarLifeOrderStatus = {
  unpaid: '00', // 待支付
  processing: '01', // 充值中
  success: '02', // 充值成功
  cancel: '03' // 已取消
};

// 车生活充值类型
export const RechargeType = {
  account: 1, // 账号直充
  recharge: 2, // 卡密兑换
  coupon: 3 // 券码兑换
};

// 产品类型
export const ProductCode = {
  'phoneCharge': 'FL00000002', //  话费充值2
  'fuelCharge': 'FL00000003', //  加油卡充值2
  'akeyFuel': 'FL20000002', // 一键加油2
  'violation': 'FL80000002', // 违章
  'ticket': 'FL80000003', // 罚单
  'virturalItem': 'FL30000001', // 虚拟物品大类  1
  'giftCard': 'FL30000002', // 礼品卡2
  'mediaCard': 'FL30000003'// 视听卡2
};

// 卡面对应图片code
export const CardMap = {
  '沃尔玛礼品卡': 'PD1506441834547773440',
  '携程任我行': 'PD1506440644363681792',
  '唯品会': 'PD1506439131767635968',
  '天猫购物券': 'PD1506174260601815040',
  '天猫超市享淘卡': 'PD1506159648875610112',
  '京东E卡': 'PD1506092912084123648',
  '苏宁卡': 'PD1502551859536248832',
  '迅雷超级会员': 'PD1505111928144527360',
  '迅雷白金': 'PD1505111306439622656',
  '百度文库会员': 'PD1505110802942787584',
  '腾讯体育高级会员': 'PD1505110254667563008',
  '腾讯体育会员': 'PD1505109752882003968',
  '同程艺龙黑鲸会员': 'PD1505109162814734336',
  '新浪微博会员': 'PD1505108570428014592',
  'QQ阅读会员': 'PD1505107310098382848',
  'QQ黄钻豪华版': 'PD1505106775140073472',
  'QQ黄钻贵族': 'PD1505106436865261568',
  'QQ超级会员': 'PD1505105753420201984',
  'QQ会员': 'PD1505105410724593664',
  '微云超级会员': 'PD1505104523557994496',
  '欢喜首映会员': 'PD1505010672818323456',
  '埋堆堆VIP': 'PD1505009650888736768',
  '南瓜电影VIP': 'PD1505009048397938688',
  '酷我音乐包': 'PD1505008420812619776',
  '酷我豪华VIP': 'PD1505006921550266368',
  '网易云音乐黑胶VIP': 'PD1505005778879250432',
  '酷狗豪华VIP': 'PD1504998080402030592',
  'QQ音乐绿钻豪华版': 'PD1504995004832153600',
  '搜狐视频黄金会员': 'PD1504992079338668032',
  '芒果TV全屏': 'PD1504990701321060352',
  '芒果移动PC端': 'PD1504781281899184128',
  '酷喵VIP': 'PD1504760969606332416',
  '腾讯超级影视VIP': 'PD1503921292523474944',
  '爱奇艺京东PLUS联名': 'PD1503919454751428608',
  '腾讯视频VIP': 'PD1503651468614438912',
  '优酷VIP': 'PD1502194722977005568',
  '爱奇艺星钻VIP': 'PD1501004851935657984',
  '爱奇艺黄金VIP会员': 'PD1500796485170786304'
};

// 平安对接
// 产品类型
export const paicProductCode = {
  categoryCode_FL10000001: 'FL10000001', //  道路救援大类1
  categoryCode_FL10000002: 'FL10000002', //  拖车2
  categoryCode_FL10000003: 'FL10000003', //  地库拖车2
  categoryCode_FLA0000002: 'FLA0000002' // 困境救援2
};

// 通用产品类型
export const generalProductCode = {
  categoryCode_FL10000001: 'FL10000001', //  道路救援大类1
  categoryCode_FL10000002: 'FL10000002', //  拖车2
  categoryCode_FL10000003: 'FL10000003', //  地库拖车2
  categoryCode_FL10000004: 'FL10000004', //  轮胎打气2
  categoryCode_FL10000005: 'FL10000005', //  更换轮胎2
  categoryCode_FL10000006: 'FL10000006', //  搭电2
  categoryCode_FL10000007: 'FL10000007', //  取送钥匙2
  categoryCode_FL10000008: 'FL10000008', //  送水2
  categoryCode_FL10000009: 'FL10000009', //  送油2
  categoryCode_FL10000010: 'FL10000010', //  送防冻液2
  categoryCode_FL10000011: 'FL10000011', //  现场维修2
  categoryCode_FL10000014: 'FL10000014', //  拖车责任险2
  categoryCode_FL90000001: 'FL90000001', // 事故救援1
  categoryCode_FL90000002: 'FL90000002', // 事故拖车2
  categoryCode_FL90000003: 'FL90000003', // 事故困境2
  categoryCode_FL90000004: 'FL90000004', // 事故救援2
  categoryCode_FLA0000001: 'FLA0000001', // 困境救援1
  categoryCode_FLA0000002: 'FLA0000002' // 困境救援2
};

export const ORDER_STATUS_CODE = {
  // 处理中
  processing: 'PROCESSING',
  // 初审退回
  auditReturn: 'AUDIT_RETURN',
  // 结算退回
  settlementReturn: 'SETTLEMENT_RETURN'
};

export const TASK_STATUS_CODE = {
  take: 'TAKE', // ("已接单"),对应待服务页面
  start: 'START', // ("已出发"),对应待到达页面
  arrive: 'ARRIVE', // ("已到达"),对应任务执行页面
  workStart: 'WORK_START', // ("作业开始"),对应开始拖车页面
  workEnd: 'WORK_END', // ("作业结束"),对应拖车完成页面
  cancel: 'CANCEL', // ("已撤销（无费）"),
  cancelFee: 'CANCEL_FEE', // ("已办理（撤销有费）"),
  cancelOrder: 'CANCEL_ORDER', // ("已办理（撤销订单）"),
  finish: 'FINISH', // ("已办理"),对应任务完成页面
  canceling: 'CANCELING', // ("取消中（无费）"),
  canceling_fee: 'CANCELING_FEE' // ("取消中（有费）")
};

export default {
  HTTP_CODE,
  TemplateType,
  VehicleConfig,
  ServiceSteps,
  Services,
  OrderStatus,
  OrderStatusTxt,
  TaskStatus,
  TaskStatusTxt,
  ServiceTypes,
  ZBServicePhone,
  ProductCode,
  CardMap,
  CarLifeOrderStatus
};

